import { Size, Token, } from "../../../core";
export class ConeToken extends Token {
    constructor(id, position, color) {
        super(id, position, ConeToken.size);
        this.color = color;
    }
    static isReadonlyInstance(token) {
        return token instanceof ConeToken;
    }
}
ConeToken.size = new Size(17 / 24, 1);
export function getConeTokenFactory(color) {
    return (id, position) => {
        return new ConeToken(id, position, color);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZS10b2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zcG9ydHMvY29tbW9uL2RyaWxsL2NvbmUtdG9rZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUlMLElBQUksRUFDSixLQUFLLEdBRU4sTUFBTSxlQUFlLENBQUM7QUFFdkIsTUFBTSxPQUFPLFNBQVUsU0FBUSxLQUFLO0lBQ2xDLFlBQVksRUFBVSxFQUFFLFFBQWtCLEVBQUUsS0FBWTtRQUN0RCxLQUFLLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDcEMsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7SUFDckIsQ0FBQztJQU1ELE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxLQUFvQjtRQUM1QyxPQUFPLEtBQUssWUFBWSxTQUFTLENBQUM7SUFDcEMsQ0FBQzs7QUFKZSxjQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQztBQVc5QyxNQUFNLFVBQVUsbUJBQW1CLENBQUMsS0FBWTtJQUM5QyxPQUFPLENBQUMsRUFBVSxFQUFFLFFBQWtCLEVBQUUsRUFBRTtRQUN4QyxPQUFPLElBQUksU0FBUyxDQUFDLEVBQUUsRUFBRSxRQUFRLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDNUMsQ0FBQyxDQUFDO0FBQ0osQ0FBQyJ9